// Package Imports
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Models
import { Result } from '../../models/Result/Result';

// Services
import { AppConfigService } from '../../services/app-config/app-config.service';
import { IdleSessionService } from '../../services/idle-session/idle-session.service';
import { OeHttpClientService } from '../../services/oe-http-client/oe-http-client.service';
import { SessionService } from '../../services/session/session.service';

@Component({
  selector: 'app-keep-session-alive',
  templateUrl: './keep-session-alive.component.html',
  styleUrls: ['./keep-session-alive.component.css']
})
export class KeepSessionAliveComponent implements OnInit {
  private readonly apiUrl: string;

  constructor(private readonly appConfigService: AppConfigService,
              private readonly idleSessionService: IdleSessionService,
              private readonly oeHttpClient: OeHttpClientService,
              private readonly router: Router,
              private readonly sessionService: SessionService) {
    this.apiUrl = `${this.appConfigService.getData('apiEndpoint')}/session/keepalive`;
  }

  ngOnInit() {
    const keepAliveReq = this.sessionService.getSessionData(this.sessionService.sessionKey_KeepSessionAlive);

    if (keepAliveReq) {
      this.sessionService.storeSessionData(this.sessionService.sessionKey_KeepSessionAlive, false);
      this.oeHttpClient.get(this.apiUrl).subscribe((res: Result<boolean>) => {
        if (res.data) {
          this.idleSessionService.reset();
        }
      });
    }
    else {
      this.sessionService.storeSessionData(this.sessionService.sessionKey_KeepSessionAlive, true);
      this.router.navigate(['/ssologin']);
    }
  }
}
